
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getBudgetInterDivisionDetailDtoFormGroup() {
return new FormGroup({
    userId: new FormControl<number | undefined>(undefined, [Validators.required]),
    firstName: new FormControl<string | undefined>(undefined),
    lastName: new FormControl<string | undefined>(undefined),
    userDivisionName: new FormControl<string | undefined>(undefined),
    projectId: new FormControl<number | undefined>(undefined, [Validators.required]),
    projectNumber: new FormControl<string | undefined>(undefined),
    projectDivisionName: new FormControl<string | undefined>(undefined),
    hours: new FormControl<number | undefined>(undefined, [Validators.required]),
    ratePerHour: new FormControl<number | undefined>(undefined, [Validators.required]),
    value: new FormControl<number | undefined>(undefined, [Validators.required]),
})
;
}
      